<template lang="pug">
.other-facilities-judged-result-modal
  b-modal(v-model="_value" size="xl" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span 他施設の判定結果
    
    b-form-select.options.mr-3.ml-3(v-model="facilityId" :options="options" @change="changeWaiter")
    .mb-3
    .template-container(v-if="waiter != null")
      .has-template(v-if="_templateAnswer != null")
        .template(v-for="(property, index) in _templateAnswer.properties")
          WaiterJudgeTemplateItem(v-model="_templateAnswer.properties[index]" :isChaild="false")
        .mb-3
        .d-flex.flex-row.justify-content-end
          span.judge-status(v-if="_judged == true") 判定済
          span.judge-status(v-else) 未判定
          .mr-3
          span.point.mr-2 合計
          span.point.mr-2 {{ point }}
          span.point 点
      .no-template(v-else)
        span 未判定

    template(#modal-footer="{ cancel }")
      b-button.btn.modal-cancel-btn(@click="cancel") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { WaitersGetModel } from "@/commons/services/Waiters";
import WaiterJudgeTemplateItem from "@/pc/containers/waiters/WaiterJudgeTemplateItem.vue";
import {
  CalcType,
  Template,
  TemplateItem,
  TemplateItemMultipleCheckbox,
  TemplateItemRadio,
  TemplateItemRadioGroup,
  TemplateItemSection,
  TemplateItemText,
  TemplateType
} from "@/commons/services/AdmissionJudgementTemplates";

/**
 * ### 他施設の判定結果モーダル
 */
@Component({
  components: {
    WaiterJudgeTemplateItem
  }
})
export default class OtherFacilitiesJudgedResultModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 施設選択肢 */
  @Prop()
  options!: Array<{ value: string; text: string }>;
  /** 待機者 */
  @Prop()
  waiters!: Array<WaitersGetModel>;

  /** 選択した施設 */
  facilityId: string = "";
  /** 表示対象の待機者 */
  waiter: WaitersGetModel | null = null;
  /** 合計点 */
  point: number = 0;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _templateAnswer(): Template | null {
    if (this.waiter == null) {
      return null;
    }
    if (this.waiter.waiter.admissionJudgement == null) {
      return null;
    }
    return this.waiter.waiter.admissionJudgement.templateAnswer;
  }

  get _judged(): boolean {
    if (this.waiter == null) {
      return false;
    }
    if (this.waiter.waiter.admissionJudgement == null) {
      return false;
    }
    return this.waiter.waiter.admissionJudgement.judged;
  }

  public changeWaiter(): void {
    if (this.facilityId == "") {
      this.waiter = null;
      this.point = 0;
      return;
    }

    for (const waiter of this.waiters) {
      if (waiter.facilityId == Number(this.facilityId)) {
        this.waiter = waiter;
        this.point = this.calculatePoint(waiter);

        return;
      }
    }

    return;
  }

  public calculatePoint(waiter: WaitersGetModel): number {
    if (waiter.waiter.admissionJudgement == null) {
      return 0;
    }

    let totalPoint: number = 0;
    let replacePoint: number | null = null;
    let points: { totalPoint: number; replacePoint: number | null } = { totalPoint, replacePoint };
    this.calculateReplacePoint(waiter.waiter.admissionJudgement.templateAnswer.properties, points);
    this.calculateTotalPoint(waiter.waiter.admissionJudgement.templateAnswer.properties, points);

    if (points.replacePoint != null) {
      return points.replacePoint;
    } else {
      return points.totalPoint;
    }
  }

  public calculateReplacePoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateReplacePoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateReplacePoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: TemplateItemText = property as TemplateItemText;
          if (textItem.answer == null) {
            continue;
          }
          if (textItem.calcType == CalcType.REPLACE) {
            points.replacePoint = Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: TemplateItemRadio = property as TemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }
          if (radioItem.calcType == CalcType.REPLACE) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.replacePoint = option.point ? Number(option.point) : (option.point as null);
                break;
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: TemplateItemMultipleCheckbox = property as TemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.REPLACE) {
            let point: number | null = null;
            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }
                if (point == null || point < Number(multipleCheckboxItem.points[i])) {
                  point = Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            points.replacePoint = point != null ? point : null;
          }
        }
      }
    }
    return;
  }

  public calculateTotalPoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateTotalPoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateTotalPoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: TemplateItemText = property as TemplateItemText;
          if (textItem.answer == null) {
            continue;
          }
          if (textItem.calcType == CalcType.ADD || textItem.calcType == CalcType.CALC_ADD) {
            points.totalPoint += Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: TemplateItemRadio = property as TemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }
          if (radioItem.calcType == CalcType.ADD || radioItem.calcType == CalcType.CALC_ADD) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.totalPoint += Number(option.point);
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: TemplateItemMultipleCheckbox = property as TemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.ADD || multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
            let point: number = 0;

            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }

                // 計算種別：加算の場合は選択肢で最高得点を採用する
                if (multipleCheckboxItem.calcType == CalcType.ADD) {
                  if (point < Number(multipleCheckboxItem.points[i])) {
                    point = Number(multipleCheckboxItem.points[i]);
                  }
                }
                // 計算種別：計算加算の場合は選択されたpointを合算する
                else if (multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
                  point += Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            // 計算種別：計算加算の場合は上限までの点数とする
            if (multipleCheckboxItem.calcType == CalcType.CALC_ADD && multipleCheckboxItem.limitPoint != null && multipleCheckboxItem.limitPoint != undefined) {
              if (multipleCheckboxItem.limitPoint < point) {
                point = multipleCheckboxItem.limitPoint;
              }
            }

            points.totalPoint += point;
          }
        }
      }
    }
    return;
  }

  public cancel(): void {
    this.waiter = null;
    this.facilityId = "";
    this.point = 0;

    this.$emit("cancel");
    return;
  }
}
</script>

<style lang="scss" scoped>
.judge-status,
.point {
  font-weight: bold;
  font-size: 20px;
}
.options {
  width: 50%;
}
</style>
